import { EventEmitter, Injectable, Input, Output } from "@angular/core";
import { MixinInjectorConstructor } from "./mixin";
import { BfxInputControlStateEnum } from "../models/base-components.enums";

/**
 * for use in Order Entry context
 */
export const ExternalStateMixin = <CLAZZ extends MixinInjectorConstructor>(Clazz: CLAZZ) => {
  @Injectable()
  abstract class ExternalState extends Clazz {
    private _externalState: BfxInputControlStateEnum;

    public get externalState(): BfxInputControlStateEnum {
      return this._externalState;
    }

    @Input()
    public set externalState(value: BfxInputControlStateEnum) {
      this._externalState = value;
      this.externalStateChange.emit(value);
    }

    protected externalStateChange = new EventEmitter<BfxInputControlStateEnum>();
  }

  return ExternalState;
};

export const ExternalStateMixinInputs = ["externalState"];
